import React from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';
import {IncompleteManagerRevieweesState} from '../state';
import {withState} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const IncompleteManagerReviewees = observer(({uiState}) => {
  const {incompleteManagerReviews} = uiState;

  if (_.isEmpty(incompleteManagerReviews)) return null;

  return (
    <div>
      <FormattedMessage id='performance_reviews.view.Manager Reviews for the following reviewees have not yet been submitted:'/>
      <div className='px2 my1 clearfix jumbo'>
        {incompleteManagerReviews.map(review => <div className='col col-6'>
          {review.reviewee.employee.name}
        </div>)}
      </div>
      <FormattedMessage id='performance_reviews.view.Ending this cycle will share submitted reviews with employees and prevent any further edits.'/>
    </div>
  );
});

export default withState(IncompleteManagerReviewees, IncompleteManagerRevieweesState);
